<template>
  <div class="home">
    <div class="top">
      <div
        :class="{ 'operating-video': true, 'operating-videoA': videoHover }"
        @mouseleave="videoLeave"
        @mouseover="videoOver"
      >
        <img
          class="operating-video-icon"
          :src="
            videoHover
              ? require('../../../images/operatingVideoA.png')
              : require('../../../images/operatingVideo.png')
          "
          alt=""
        />
        <div>使用指南</div>
      </div>
      <!-- <div class="top-button" @click="navigateTo('/register')">注册</div> -->
      <div
        v-if="role == 2"
        class="top-button"
        @click="navigateTo('search')"
        @mouseover="mouseover(1)"
        @mouseleave="mouseleave"
      >
        <img
          class="button-icon"
          :src="
            mouseNum == 1
              ? require('../../assets/search2.png')
              : require('../../assets/search.png')
          "
          alt=""
        />
        搜索资源
      </div>
      <div
        v-if="role == 1 || role == 2"
        class="top-button"
        @click="navigateTo('upload')"
        @mouseover="mouseover(2)"
        @mouseleave="mouseleave"
      >
        <img
          class="button-icon"
          :src="
            mouseNum == 2
              ? require('../../assets/upload2.png')
              : require('../../assets/upload.png')
          "
          alt=""
        />上传资源
      </div>
    </div>
    <div class="menu-container">
      <!-- <div class="menu">
        <img
          class="menu-icon"
          :src="require('../../assets/jcptzy.png')"
          alt=""
          @click="navigateTo('/bookResource')"
        />
        <div class="menu-name">配套资源</div>
      </div>
      <div class="menu">
        <img
          class="menu-icon"
          :src="require('../../assets/bxzy.png')"
          alt=""
          @click="navigateTo('/schoolResource')"
        />
        <div class="menu-name">本校资源</div>
      </div>
      <div class="menu">
        <img class="menu-icon" :src="require('../../assets/wdgz.png')" alt="" />
        <div class="menu-name">我的关注</div>
      </div>
      <div class="menu">
        <img class="menu-icon" :src="require('../../assets/wdzy.png')" alt="" />
        <div class="menu-name">我的主页</div>
      </div> -->

      <div
        v-for="item in menuList"
        :key="item.name"
        class="menu"
        @click="navigateTo(item.path)"
      >
        <img
          class="menu-icon"
          :src="require('@/assets/' + item.icon + '.png')"
          alt=""
        />
        <div class="menu-name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data: () => ({
    role: 0, // 身份 1超管 2老师 3学校
    menuListAll: [
      [
        {
          icon: 'jcptzy',
          name: '配套资源',
          path: 'bookResource',
        },
        {
          icon: 'zysh',
          name: '资源审核',
          path: 'examine',
        },
        {
          icon: 'zhgl',
          name: '帐号管理',
          path: 'account',
        },
      ],
      [
        {
          icon: 'jcptzy',
          name: '配套资源',
          path: 'bookResource',
        },
        // {
        //   icon: 'bxzy',
        //   name: '本校资源',
        //   path: '',
        // },
        {
          icon: 'wdgz',
          name: '我的关注',
          path: 'followResource',
        },
        {
          icon: 'wdzy',
          name: '我的主页',
          path: 'mine',
        },
      ],
      [
        {
          icon: 'zysh',
          name: '资源审核',
          path: 'examine',
        },
        {
          icon: 'bxzy',
          name: '园内资源管理',
          path: 'schoolResource',
        },
        {
          icon: 'zhgl',
          name: '帐号管理',
          path: 'account',
        },
        {
          icon: 'wdzy',
          name: '我的主页',
          path: 'schoolMine',
        },
      ],
    ],
    menuList: [],
    mouseNum: 0,
    videoHover: false,
  }),

  beforeRouteEnter(to, from, next) {
    console.log('from', from)
    let edit = from.params.edit
    console.log('edit', edit)
    if (edit) {
      window.location.reload()
    }
    next()
  },
  async mounted() {
    let user = JSON.parse(localStorage.getItem('yey-user'))
    if (!user) {
      return
    }
    if (user.role == 'admin') {
      this.role = 1
    }
    if (user.role == 'teacher') {
      this.role = 2
    }
    if (user.role == 'school') {
      this.role = 3
    }
    this.menuList = this.menuListAll[this.role - 1]
  },
  methods: {
    navigateTo(url) {
      console.log('url', url)

      if (!url) {
        return
      }
      if (url == 'mine') {
        sessionStorage.removeItem('yey-mineMenuIndex')
        sessionStorage.removeItem('yey-teacherResourceIndex')
      }
      if (url == 'bookResource') {
        sessionStorage.removeItem('yey-typeIndex')
        sessionStorage.removeItem('yey-menuIndexInit')
        sessionStorage.removeItem('yey-detailId')
        sessionStorage.removeItem('yey-detail')
      }
      if (url == 'search') {
        sessionStorage.removeItem('yey-searchInfo')
        sessionStorage.removeItem('yey-searchDetail')
      }
      if (url == 'schoolResource') {
        sessionStorage.removeItem('yey-schoolResourceDetail')
      }

      this.$router.push(url)
    },

    mouseover(num) {
      this.mouseNum = num
    },
    mouseleave() {
      this.mouseNum = 0
    },

    videoOver() {
      this.videoHover = true
    },
    videoLeave() {
      this.videoHover = false
    },
  },
}
</script>

<style lang="less" scoped>
.home {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  height: 100%;
  background-color: rgba(#5ccbf7, 0.2);
  background-image: url('../../assets/bottomBg.png');
  background-size: 100% 220px;
  background-position: 0 calc(100vh - 320px);
  background-repeat: no-repeat;
}
.top {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 42px;
  right: 0;
  padding-right: 10px;
}
.top-button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  width: 229px;
  height: 70px;
  margin-right: 30px;
  font-size: 22px;
  color: #333;
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 35px;
  user-select: none;
  cursor: pointer;
}

.top-button:hover {
  background: #ffffff;
  box-shadow: 0px 0px 30px 0px rgba(49, 152, 194, 0.3);
}

.button-icon {
  width: 26px;
  height: 26px;
  margin-right: 20px;
}
.menu-container {
  width: 100%;
  height: 349px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  padding-bottom: 100px;
}
.menu {
  // width: 300px;
  // height: 349px;
  width: 270px;
  height: 314px;
  // margin-right: 80px;
  margin: 0 40px;
  border-radius: 40px;
  background-color: #fff;
  overflow: hidden;
  user-select: none;
  cursor: pointer;
  // &:last-child {
  //   margin-right: 0;
  // }
  transition: all 0.3;
}
.menu:hover {
  width: 300px;
  height: 349px;
  margin: 0 25px;
  box-shadow: 0px 0px 100px 0px rgba(49, 152, 194, 0.3);
  .menu-icon {
    width: 162px;
    height: 162px;
    margin: 64px auto 36px;
  }
  .menu-name {
    font-size: 22px;
    color: #285167;
  }
}
.menu-icon {
  display: block;
  // width: 162px;
  // height: 162px;
  // margin: 64px auto 36px;
  width: 146px;
  height: 146px;
  margin: 58px auto 32px;
}
.menu-name {
  text-align: center;
  font-size: 22px;
  // color: #56839b;
  color: #285167;
}

.operating-video {
  position: fixed;
  top: 130px;
  left: 60px;
  width: 110px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #808080;
  line-height: 60px;
  cursor: pointer;
  .operating-video-icon {
    width: 22px;
    height: 22px;
    // margin-right: 5px;
  }
}
.operating-videoA {
  color: #0da1f1;
}
</style>
